import { mapActions } from 'vuex';
import { getOwnerId } from '../getOwnerId';

export default {
  methods: {
    ...mapActions({
      fetchParticipantMembersforCheck: 'events/fetchParticipantMembersforCheck',
    }),
    // async goToMP(eventId) {
    //   let available = false;
    //   if (this.$lodash.get(this.currentEvent, 'id') === eventId && this.$route.path.includes('meeting-planner')) return;
    //   await this.fetchParticipantMembersforCheck({
    //     eventId,
    //     searchName: '',
    //   }).then((res) => {
    //     res.forEach(({ details: { customer_id } }) => {
    //       if (customer_id === getOwnerId()) available = true;
    //     });
    //   });
    //   if (available) {
    //     this.$router.push({ name: 'meetingPlanner', params: { eventId } });
    //   } else {
    //     this.$notify({
    //       group: 'userAlerts',
    //       title: 'ACCESS DENIED',
    //       text: 'Your access to Meeting Planner denied from CC Admin',
    //       type: 'info',
    //     });
    //   }
    // },
    isAvailable(participants) {
      let available = false;
      participants.forEach(({ customer_id, display }) => {
        if (customer_id === getOwnerId()) available = display;
      });
      return available;
    },
  },
};
